import {
  AlertDialog,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import React, { memo, useRef } from "react";

import { usePWADevice } from "src/providers/PWADeviceProvider";

type Props = {
  onCloseDialog: () => void;
};

export const CheckInConfirmDialog = memo<Props>(({ onCloseDialog }) => {
  const { isFirstMobilePWAVisit } = usePWADevice();
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: !isFirstMobilePWAVisit });

  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={() => {
        onClose();
        onCloseDialog();
      }}
      leastDestructiveRef={cancelRef}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader py="12px" fontSize="16px" textAlign="center">
            確認
          </AlertDialogHeader>

          <AlertDialogCloseButton _focus={{ boxShadow: "white" }} />

          <AlertDialogBody
            borderTop="1px"
            borderColor="gray.200"
            py="24px"
            textAlign="center"
            fontSize="14px"
          >
            チェックイン通知音設定がONになっています。
          </AlertDialogBody>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
});
